import React from 'react'

import { SelectPicker } from 'rsuite'

import { PRODUCT_STATUS_LABELS } from '@@partner:config/product'
import { TypeAttributes } from 'rsuite/esm/internals/types'

export interface ProductStatusProps {
  value?: number
  onChange: (value: number | null) => void
  menuStyle?: React.CSSProperties
  placement?: TypeAttributes.Placement
  cleanable?: boolean
}

export default function ProductStatus ({
  value,
  onChange,
  menuStyle,
  placement,
  cleanable = false
}: ProductStatusProps) {
  return (
    <SelectPicker
      placement={placement}
      data={PRODUCT_STATUS_LABELS}
      labelKey="label"
      valueKey="value"
      value={value ?? null}
      onChange={(value) => onChange?.(value)}
      cleanable={cleanable}
      searchable={false}
      menuStyle={menuStyle}
      placeholder="Не выбран"
    />
  )
}
